import { uploadFile } from '../../utils/Api'

/**
 * Sender IDs are government ID photos of people who aren't our customers, so
 * the server stores them privately. `senderIdImage` on a booking/draft is an
 * opaque reference (`cld-private:…`) — submit it as-is, never display it.
 * What can be shown is `senderIdImageUrl` (or the upload's `previewUrl`): a
 * signed link that expires after 10 minutes.
 *
 * Records from before the switch still hold a public https URL in
 * senderIdImage, which is displayable as-is.
 */
export const senderIdDisplayUrl = (
  senderIdImage?: string | null,
  senderIdImageUrl?: string | null
): string | null =>
  senderIdImageUrl ||
  (senderIdImage && /^https?:\/\//i.test(senderIdImage) ? senderIdImage : null)

type UploadResult =
  | { ok: true; senderIdImage: string; previewUrl: string | null }
  | { ok: false; message: string }

/** Private, authenticated upload (POST admin/sender-id/upload). */
export const uploadSenderId = async (file: File): Promise<UploadResult> => {
  const formData = new FormData()
  formData.append('image', file)
  try {
    const result = await uploadFile(formData, 'admin/sender-id/upload')
    if (result.status === 201 && result.data?.senderIdImage) {
      return {
        ok: true,
        senderIdImage: result.data.senderIdImage,
        previewUrl: result.data.previewUrl ?? null,
      }
    }
    return { ok: false, message: result.message || 'Failed to upload ID' }
  } catch {
    return { ok: false, message: 'Failed to upload ID' }
  }
}
